{{ text() }}
@if (shortcut()) {
  <kbd>{{ shortcut() }}</kbd>
}
